"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCourseWrapperMediator = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdReactRouter = require("cccisd-react-router");
var _finalTestStatus = _interopRequireDefault(require("./finalTestStatus.graphql"));
var _externalRegistrationStatus = _interopRequireDefault(require("./externalRegistrationStatus.graphql"));
var _curriculumProgress = _interopRequireDefault(require("./curriculumProgress.graphql"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _curriculumResettableDeployments = _interopRequireDefault(require("./curriculumResettableDeployments.graphql"));
var _dateFns = require("date-fns");
var _index = require("./index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var tabs = ['courseDescription', 'registration', 'course', 'finalTest', 'courseEval', 'certificate', 'resources'];
var Boilerplate = window.cccisd.boilerplate;
var useCourseWrapperMediator = function useCourseWrapperMediator(_ref) {
  var _history$location;
  var actingPawnId = _ref.actingPawnId,
    actingPawnHash = _ref.actingPawnHash,
    basePath = _ref.basePath,
    handle = _ref.handle,
    curriculumRelatedDeploymentId = _ref.deploymentId,
    isPreviewMode = _ref.isPreviewMode,
    mediatorProps = _ref.mediatorProps,
    onAssignmentComplete = _ref.onAssignmentComplete,
    onComplete = _ref.onComplete,
    onFlowComplete = _ref.onFlowComplete,
    onFlowStarted = _ref.onFlowStarted,
    originalFlowList = _ref.originalFlowList;
  var certificate = mediatorProps.certificate,
    course = mediatorProps.course,
    courseDescription = mediatorProps.courseDescription,
    courseEval = mediatorProps.courseEval,
    finalTest = mediatorProps.finalTest,
    registration = mediatorProps.registration,
    resources = mediatorProps.resources;
  var history = (0, _cccisdReactRouter.useHistory)();
  var params = (0, _cccisdReactRouter.useParams)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    curriculumProps = _useState2[0],
    setCurriculumProps = _useState2[1];
  var _useState3 = (0, _react.useState)(_toConsumableArray(originalFlowList)),
    _useState4 = _slicedToArray(_useState3, 2),
    flowList = _useState4[0],
    setFlowList = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasVisitedCertificate = _useState6[0],
    setHasVisitedCertificate = _useState6[1];
  var _useState7 = (0, _react.useState)({
      summary: null,
      list: []
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    finalTestData = _useState8[0],
    setFinalTestData = _useState8[1];
  // startedComplete is `true` after taking an external final test, so we
  // need a special flag to know if we finished before
  var _useState9 = (0, _react.useState)(true),
    _useState10 = _slicedToArray(_useState9, 2),
    finalTestStartedComplete = _useState10[0],
    setFinalTestStartedComplete = _useState10[1];
  var _useState11 = (0, _react.useState)({}),
    _useState12 = _slicedToArray(_useState11, 2),
    latestFinalTestData = _useState12[0],
    setLatestFinalTestData = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    finalTestDataRetrievedCount = _useState14[0],
    setFinalTestDataRetrievedCount = _useState14[1];

  // loading state to prevent automatically pushing to first tab until we
  // know which tab to start on. May have race condition bug with getCurrentTabs??
  var _useState15 = (0, _react.useState)(true),
    _useState16 = _slicedToArray(_useState15, 2),
    isExternalRegistrationLoading = _useState16[0],
    setIsExternalRegistrationLoading = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isExternalRegistrationComplete = _useState18[0],
    setIsExternalRegistrationComplete = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isExternalRegistrationCompleteLocally = _useState20[0],
    setIsExternalRegistrationCompleteLocally = _useState20[1];
  var showExternalRegistrationDeployment = registration && registration.toggle && registration.isExternalRegistration && !isExternalRegistrationComplete && !isExternalRegistrationCompleteLocally;
  var _useState21 = (0, _react.useState)(false),
    _useState22 = _slicedToArray(_useState21, 2),
    hasCompletedLocally = _useState22[0],
    setHasCompletedLocally = _useState22[1];
  var isRepeatedFinalTest = finalTest && finalTest.toggle && finalTest.useRepeatingFinalTest;
  var startedComplete = originalFlowList.filter(function (f) {
    return !f.isComplete;
  }).length === 0;
  var isCourseFullyComplete = isTabMediatorComplete('course');
  var isCourseEvalComplete = isTabMediatorComplete('courseEval');
  var isFinalTestComplete = isTabMediatorComplete('finalTest');
  var isRegistrationComplete = isTabMediatorComplete('registration');
  var isCourseComplete = course.isCurriculum ? isCourseFullyComplete : flowList.filter(function (f) {
    return mediatorProps.course.options.includes(f.handle) && f.isRequired && !f.isComplete;
  }).length === 0;
  var availableTabs = tabs.filter(function (tab) {
    return mediatorProps[tab] && mediatorProps[tab].toggle && (tab !== 'registration' || registration.isInternalRegistration || registration.isExternalRegistration);
  });

  /* since shortHash is optional second param, handle case where shortHash is missing
   * and second param is actually courseWrapperTab */
  var currTab = params.courseWrapperTab || availableTabs.find(function (t) {
    return t === params.shortHash;
  });
  /* One final check in case Course Wrapper is rendered on a custom app route
   * (not via DeploymentEvaluator) */
  if (!currTab && history !== null && history !== void 0 && (_history$location = history.location) !== null && _history$location !== void 0 && _history$location.pathname) {
    var search = history.location.pathname.search(_index.courseWrapperTabWhitelistRegex);
    if (search !== -1) {
      // remove beginning slash /
      currTab = history.location.pathname.slice(search + 1);
    }
  }
  var currentTabs = course.isCurriculum && course.curriculumTabStyle === 'side' ? getCurrentSideTabsCurriculum() : getCurrentTabs();
  var firstFlow = originalFlowList.length && originalFlowList[0];
  var relatedDeploymentId = firstFlow ? firstFlow.responseSet : null;

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE METHODS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function getCurriculumData() {
      return _getCurriculumData.apply(this, arguments);
    }
    function _getCurriculumData() {
      _getCurriculumData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var mainResponse, mainProgress, deployments, repeatedResponses, deploymentsForCurriculum, deploymentIdsToFetch, newDeploymentsResp, newDeployments, mustTakeInOrder;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _cccisdApollo.client.query({
                  query: _curriculumProgress["default"],
                  variables: {
                    mainDeploymentId: curriculumRelatedDeploymentId,
                    deploymentIds: course.curriculumOptions.map(function (d) {
                      return d.deploymentId;
                    }),
                    actingPawnId: actingPawnId
                  },
                  fetchPolicy: 'network-only'
                });
              case 2:
                mainResponse = _context2.sent;
                mainProgress = (0, _get2["default"])(mainResponse, 'data.mainAssignment.assignmentProgress', null);
                delete mainProgress.__typename;
                deployments = (0, _get2["default"])(mainResponse, 'data.flows.deploymentList', []) || []; // forceRenewable is backdoor JSON way to have repeatable curriculum without a certificate
                if (!(!isPreviewMode && (certificate.toggle && certificate.allowRenew || certificate.forceRenewable))) {
                  _context2.next = 20;
                  break;
                }
                _context2.next = 9;
                return Promise.all(course.curriculumOptions.map(function (_ref2) {
                  var _deployments$find, _deployments$find$set;
                  var parentDeploymentId = _ref2.deploymentId;
                  var isRepeated = (_deployments$find = deployments.find(function (d) {
                    return Number(d.deploymentId) === Number(parentDeploymentId);
                  })) === null || _deployments$find === void 0 ? void 0 : (_deployments$find$set = _deployments$find.settings) === null || _deployments$find$set === void 0 ? void 0 : _deployments$find$set.isRepeated;
                  if (!isRepeated) {
                    return Promise.resolve({
                      data: {
                        data: {
                          deploymentId: parentDeploymentId
                        }
                      }
                    });
                  }
                  return _cccisdAxios["default"].get(Boilerplate.route('api.assignmentDeployment.repeated', {
                    deploymentId: parentDeploymentId,
                    pawnId: actingPawnId,
                    hash: actingPawnHash
                  }), {
                    params: {
                      isPawnHash: true,
                      relatedDeploymentId: curriculumRelatedDeploymentId
                    }
                  });
                }));
              case 9:
                repeatedResponses = _context2.sent;
                deploymentsForCurriculum = [];
                deploymentIdsToFetch = [];
                repeatedResponses.forEach( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resp) {
                    var _resp$data, _resp$data2, _resp$data3;
                    var data, deploymentId, deployment;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (resp !== null && resp !== void 0 && (_resp$data = resp.data) !== null && _resp$data !== void 0 && _resp$data.status && (resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.status) !== 'success') {
                              console.error("Could not get repeatable deployment ID. Full error message: `".concat(resp.data.errors, "`"));
                            }
                            data = (resp === null || resp === void 0 ? void 0 : (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.data) || {};
                            deploymentId = data.deploymentId;
                            deployment = deployments.find(function (d) {
                              return d.deploymentId === deploymentId;
                            });
                            if (deployment) {
                              deploymentsForCurriculum.push(deployment);
                            } else if (deploymentId) {
                              deploymentIdsToFetch.push(deploymentId);
                            }
                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

                // cases where axios call created new timepoints, we now have to fetch them
                if (!(deploymentIdsToFetch.length > 0)) {
                  _context2.next = 19;
                  break;
                }
                _context2.next = 16;
                return _cccisdApollo.client.query({
                  query: _curriculumResettableDeployments["default"],
                  variables: {
                    deploymentIds: deploymentIdsToFetch,
                    actingPawnId: actingPawnId
                  },
                  fetchPolicy: 'network-only'
                });
              case 16:
                newDeploymentsResp = _context2.sent;
                newDeployments = (0, _get2["default"])(newDeploymentsResp, 'data.flows.deploymentList', false);
                if (Array.isArray(newDeployments)) {
                  newDeployments.forEach(function (dep) {
                    deploymentsForCurriculum.push(dep);
                  });
                }
              case 19:
                // children deployments are created with isOpen as false, so force it here
                deployments = deploymentsForCurriculum.map(function (dep) {
                  return _objectSpread(_objectSpread({}, dep), {}, {
                    isOpen: true
                  });
                });
              case 20:
                mustTakeInOrder = (0, _get2["default"])(course, 'navigationSettings.mustTakeInOrder', false);
                setCurriculumProps({
                  mainProgress: isPreviewMode ? {
                    started: false,
                    completed: false
                  } : mainProgress,
                  progress: deployments.map(function (dep, i) {
                    delete dep.__typename;
                    delete dep.assignment.__typename;
                    delete dep.assignmentProgress.__typename;
                    if (isPreviewMode) {
                      dep = _objectSpread(_objectSpread({}, dep), {}, {
                        assignmentProgress: {
                          started: false,
                          completed: false,
                          lastVisitedAt: ''
                        }
                      });
                    }
                    var options = course.curriculumOptions.find(function (d) {
                      return dep.parentDeploymentId ? dep.parentDeploymentId === d.deploymentId : dep.deploymentId === d.deploymentId;
                    });
                    return _objectSpread(_objectSpread(_objectSpread({}, options), dep), {}, {
                      isAllowed: !mustTakeInOrder || i === 0 || (0, _get2["default"])(deployments[i - 1], 'assignmentProgress.completed', false),
                      setProgress: function setProgress(started, completed) {
                        return setCurriculumDeploymentProgress(dep.deploymentId, started, completed);
                      }
                    });
                  }).sort(function (a, b) {
                    var aIndex = course.curriculumOptions.findIndex(function (dep) {
                      return a.parentDeploymentId ? a.parentDeploymentId === dep.deploymentId : a.deploymentId === dep.deploymentId;
                    }) || -1;
                    var bIndex = course.curriculumOptions.findIndex(function (dep) {
                      return b.parentDeploymentId ? b.parentDeploymentId === dep.deploymentId : b.deploymentId === dep.deploymentId;
                    }) || -1;
                    return aIndex - bIndex;
                  })
                });
              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getCurriculumData.apply(this, arguments);
    }
    if (course.toggle && course.isCurriculum && ['course', 'finalTest', 'certificate', 'courseEval'].includes(params === null || params === void 0 ? void 0 : params.courseWrapperTab)) {
      getCurriculumData();
    }
  }, [currTab, params.assignmentId]);
  (0, _react.useEffect)(function () {
    function forceComplete() {
      return _forceComplete.apply(this, arguments);
    }
    function _forceComplete() {
      _forceComplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                setHasCompletedLocally(true);
                setFinalTestStartedComplete(true);
                _context3.next = 4;
                return onAssignmentComplete();
              case 4:
                _context3.next = 6;
                return onComplete();
              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _forceComplete.apply(this, arguments);
    }
    if (curriculumProps && curriculumProps.progress && Array.isArray(curriculumProps.progress) && curriculumProps.progress.every(function (dep) {
      return !!dep.assignmentProgress.completed;
    }) && !curriculumProps.mainProgress.completed) {
      // curriculum does not have any local flows that are completable, so
      // manually trigger it whenever all inner-deployments are complete
      forceComplete();
    }
  }, [curriculumProps]);
  (0, _react.useEffect)(function () {
    if (!isExternalRegistrationLoading && (!currTab || !availableTabs.includes(currTab))) {
      history.push("".concat(basePath, "/").concat(course.isCurriculum && course.curriculumTabStyle === 'side' ? currentTabs[0].tab : currentTabs[0]));
    }
    function checkExternalRegistration() {
      return _checkExternalRegistration.apply(this, arguments);
    }
    function _checkExternalRegistration() {
      _checkExternalRegistration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var response, isComplete;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!isPreviewMode) {
                  _context4.next = 3;
                  break;
                }
                setIsExternalRegistrationLoading(false);
                return _context4.abrupt("return");
              case 3:
                if (registration.externalRegistrationDeploymentId) {
                  _context4.next = 6;
                  break;
                }
                setIsExternalRegistrationComplete(true);
                return _context4.abrupt("return");
              case 6:
                _context4.next = 8;
                return _cccisdApollo.client.query({
                  query: _externalRegistrationStatus["default"],
                  variables: {
                    deploymentId: registration.externalRegistrationDeploymentId,
                    pawnId: actingPawnId
                  },
                  fetchPolicy: 'network-only'
                });
              case 8:
                response = _context4.sent;
                isComplete = (0, _get2["default"])(response, 'data.flows.deployment.assignmentProgress.completed', false) || false;
                setIsExternalRegistrationComplete(isComplete);
                setIsExternalRegistrationLoading(false);
              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _checkExternalRegistration.apply(this, arguments);
    }
    if (registration && registration.toggle && registration.isExternalRegistration && isExternalRegistrationLoading) {
      checkExternalRegistration();
    } else if (isExternalRegistrationLoading) {
      setIsExternalRegistrationLoading(false);
    }
  }, [isExternalRegistrationLoading]);
  (0, _react.useEffect)(function () {
    if (!hasVisitedCertificate && currTab === 'certificate' && isCourseComplete && isFinalTestComplete && isCourseEvalComplete) {
      setHasVisitedCertificate(true);
    }
  }, [currTab]);
  (0, _react.useEffect)(function () {
    function getFinalTestStatuses() {
      return _getFinalTestStatuses.apply(this, arguments);
    }
    function _getFinalTestStatuses() {
      _getFinalTestStatuses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var result, finalTestSummary, date, isPassing, finalTestList;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!firstFlow || !finalTest || !finalTest.toggle || !finalTest.useRepeatingFinalTest)) {
                  _context5.next = 3;
                  break;
                }
                setFinalTestDataRetrievedCount(1);
                return _context5.abrupt("return");
              case 3:
                _context5.prev = 3;
                _context5.next = 6;
                return _cccisdApollo.client.query({
                  query: _finalTestStatus["default"],
                  fetchPolicy: 'network-only',
                  variables: {
                    parentDeploymentId: finalTest.parentDeploymentId,
                    relatedDeploymentId: relatedDeploymentId,
                    pawnId: actingPawnId
                  }
                });
              case 6:
                result = _context5.sent;
                finalTestSummary = (0, _get2["default"])(result, 'data.flows.deployment.assignmentProgress.variables', null) || null;
                if (finalTestSummary) {
                  date = finalTestSummary[Object.keys(finalTestSummary).find(function (k) {
                    return k.endsWith('_date');
                  })];
                  isPassing = !!parseInt(finalTestSummary[Object.keys(finalTestSummary).find(function (k) {
                    return k.endsWith('_pass');
                  })], 10);
                  finalTestSummary = {
                    date: date,
                    isPassing: isPassing
                  };
                  setLatestFinalTestData(function (prev) {
                    return _objectSpread(_objectSpread({}, prev), finalTestSummary);
                  });
                }
                finalTestList = (0, _get2["default"])(result, 'data.flows.deploymentList', []) || [];
                setFinalTestData({
                  summary: finalTestSummary,
                  list: finalTestList
                });
                _context5.next = 17;
                break;
              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](3);
                console.error(_context5.t0);
                setFinalTestData({
                  summary: null,
                  list: []
                });
              case 17:
                if (finalTestDataRetrievedCount === 0) {
                  setFinalTestDataRetrievedCount(1);
                }
              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[3, 13]]);
      }));
      return _getFinalTestStatuses.apply(this, arguments);
    }
    if (finalTestDataRetrievedCount !== 1 && !isPreviewMode) {
      getFinalTestStatuses();
    }
    if (finalTestDataRetrievedCount === 0 && isPreviewMode) {
      setFinalTestDataRetrievedCount(1);
    }
  }, [finalTestDataRetrievedCount]);
  (0, _react.useEffect)(function () {
    function exceededTestMaxTries() {
      return _exceededTestMaxTries.apply(this, arguments);
    }
    function _exceededTestMaxTries() {
      _exceededTestMaxTries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var resp, deployment, deploymentLastVisitedAt, testLastVisitedAt, testVisitedAfterDeployment;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(finalTest.useMaxTries && finalTest.maxTries)) {
                  _context6.next = 13;
                  break;
                }
                _context6.next = 3;
                return _cccisdApollo.client.query({
                  query: _curriculumProgress["default"],
                  variables: {
                    mainAssignmentHandle: handle,
                    deploymentIds: [relatedDeploymentId],
                    actingPawnId: actingPawnId
                  },
                  fetchPolicy: 'network-only'
                });
              case 3:
                resp = _context6.sent;
                deployment = resp.data.flows.deploymentList.find(function (x) {
                  return x.deploymentId === relatedDeploymentId;
                }); // Both times should be UTC
                deploymentLastVisitedAt = new Date(deployment.assignmentProgress.lastVisitedAt);
                testLastVisitedAt = new Date(latestFinalTestData.date);
                testVisitedAfterDeployment = (0, _dateFns.isAfter)(testLastVisitedAt, deploymentLastVisitedAt);
                if (!(latestFinalTestData.timepoint >= finalTest.maxTries && testVisitedAfterDeployment)) {
                  _context6.next = 11;
                  break;
                }
                setLatestFinalTestData(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    exceededMaxTries: true,
                    recentlyExceededMaxTries: true // Never gets set to false, once set. So we can use to not navigate back to final test on every assignment lastVisitedAt update
                  });
                });
                return _context6.abrupt("return", true);
              case 11:
                setLatestFinalTestData(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    exceededMaxTries: false
                  });
                });
                return _context6.abrupt("return", false);
              case 13:
                setLatestFinalTestData(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    exceededMaxTries: false
                  });
                });
                return _context6.abrupt("return", false);
              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _exceededTestMaxTries.apply(this, arguments);
    }
    exceededTestMaxTries();
  }, [finalTest, latestFinalTestData.date, latestFinalTestData.timepoint, params, relatedDeploymentId]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL METHODS ////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var setCurriculumDeploymentProgress = function setCurriculumDeploymentProgress(deploymentId, started, completed) {
    setCurriculumProps(function (prev) {
      // manually set assignment started_at for the main deployment
      // if there are no flows that triggered it already
      function setMainStarted() {
        return _setMainStarted.apply(this, arguments);
      }
      function _setMainStarted() {
        _setMainStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return onFlowStarted({
                    handle: ''
                  });
                case 2:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));
        return _setMainStarted.apply(this, arguments);
      }
      var mainProgress = prev.mainProgress;
      if (!prev.mainProgress.started && (started || completed)) {
        mainProgress = Object.assign({}, mainProgress, {
          started: true
        });
        setMainStarted();
      }
      var progress = _toConsumableArray(prev.progress);
      var index = progress.findIndex(function (dep) {
        return dep.deploymentId === deploymentId;
      });
      progress[index].assignmentProgress = {
        started: started,
        completed: completed
      };
      if ((0, _get2["default"])(course, 'navigationSettings.mustTakeInOrder', false) && index < progress.length - 1 && completed) {
        progress[index + 1].isAllowed = true;
      }
      return {
        mainProgress: mainProgress,
        progress: progress
      };
    });
  };
  function determineCurriculumStatus() {
    if (!course || !course.toggle || !course.isCurriculum || course.curriculumOptions.length === 0) {
      return true;
    }
    if (!(curriculumProps !== null && curriculumProps !== void 0 && curriculumProps.progress)) {
      return false;
    }
    return curriculumProps.progress.every(function (deployment) {
      var deploymentOpen = (0, _get2["default"])(deployment, 'isOpen', false);
      var deploymentCompleted = (0, _get2["default"])(deployment, 'assignmentProgress.completed', false) || false;
      return !deploymentOpen || deploymentCompleted;
    });
  }
  function determineFinalTestStatus() {
    if (!finalTest || !finalTest.toggle) {
      return true;
    }
    if (finalTestDataRetrievedCount > 1 && isPreviewMode) {
      return true;
    }
    if (finalTestDataRetrievedCount === 0) {
      return false;
    }
    var isPassing = false;
    if (finalTestData.summary) {
      isPassing = finalTestData.summary.isPassing;
    }
    if (finalTestData.list.length === 0) {
      if (isPassing) {
        return true;
      }
      if (finalTestStartedComplete) {
        setFinalTestStartedComplete(false);
      }
      return false;
    }
    var latestData = {};

    /* flag to make sure assignmentProgress only fires once instead of once for every attempt */
    var tryingAssignmentComplete = false;
    var _iterator = _createForOfIteratorHelper(finalTestData.list),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ftData = _step.value;
        if (!(0, _get2["default"])(ftData, 'assignmentProgress.completed')) {
          continue;
        }
        var variables = (0, _get2["default"])(ftData, 'assignmentProgress.variables', {});
        var numCorrect = Object.values(variables).filter(function (v) {
          return typeof v === 'string' && v.toLowerCase() === 'correct';
        }).length;
        var numIncorrect = Object.values(variables).filter(function (v) {
          return typeof v === 'string' && v.toLowerCase() === 'incorrect';
        }).length;
        var denominator = numCorrect + numIncorrect;
        if (denominator === 0) {
          ftData.score = 0;
          continue;
        }
        ftData.score = numCorrect / denominator * 100;
        ftData.numCorrect = numCorrect;
        ftData.numTotal = denominator;
        ftData.passing = isPassing;
        // prevent race condition where assignment_test_pass is not calculated and
        // saved by the time finalTestData is fetched
        if (!ftData.passing && finalTest.passingThreshold && ftData.score >= Number(finalTest.passingThreshold)) {
          ftData.passing = true;
          isPassing = true;
        }
        ftData.completionDate = finalTestData && finalTestData.date ? finalTestData.date : null;
        // if courseEval is ON, it will be marked complete when that is finised via onFlowCompleteLocal
        if (isPassing && !finalTestStartedComplete && !tryingAssignmentComplete && !courseEval.toggle) {
          tryingAssignmentComplete = true;
          tryAssignmentComplete({
            finalTestComplete: true
          });
        }
        latestData = _objectSpread({}, ftData);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (latestFinalTestData.deploymentId !== latestData.deploymentId) {
      setLatestFinalTestData(function (prev) {
        return _objectSpread(_objectSpread({}, prev), latestData);
      });
    }
    if (!isPassing && finalTestStartedComplete) {
      setFinalTestStartedComplete(false);
    }
    return isPassing;
  }
  function getCurrentSideTabsCurriculum() {
    var newTabs = [];
    tabs.forEach(function (tab) {
      switch (tab) {
        case 'courseDescription':
          if (courseDescription.toggle) {
            newTabs.push({
              tab: tab,
              tabName: courseDescription.tabName
            });
          }
          break;
        case 'registration':
          if (registration.toggle && (registration.isInternalRegistration || registration.isExternalRegistration)) {
            newTabs.push({
              tab: tab,
              tabName: registration.tabName,
              isComplete: isRegistrationComplete,
              isDisabled: isRegistrationComplete,
              isLocked: false
            });
          }
          break;
        case 'course':
          if (course.toggle) {
            newTabs.push({
              tab: tab,
              tabName: course.tabName,
              isComplete: isCourseFullyComplete,
              isDisabled: !course.allowRetake && isCourseFullyComplete || !isRegistrationComplete,
              isLocked: !isRegistrationComplete
            });
          }
          break;
        case 'finalTest':
          if (finalTest.toggle) {
            newTabs.push({
              tab: tab,
              tabName: finalTest.tabName,
              isComplete: isFinalTestComplete,
              isDisabled: latestFinalTestData.exceededMaxTries || finalTest.lockedUntilCompletion && !isCourseFullyComplete || isFinalTestComplete,
              isLocked: finalTest.lockedUntilCompletion && !isCourseFullyComplete || latestFinalTestData.exceededMaxTries
            });
          }
          break;
        case 'courseEval':
          if (courseEval.toggle) {
            newTabs.push({
              tab: tab,
              tabName: courseEval.tabName,
              isComplete: isCourseEvalComplete,
              isDisabled: (!isCourseFullyComplete || !isFinalTestComplete) && courseEval.lockedUntilCompletion || isCourseEvalComplete,
              isLocked: (!isCourseFullyComplete || !isFinalTestComplete) && courseEval.lockedUntilCompletion
            });
          }
          break;
        case 'certificate':
          if (certificate.toggle) {
            newTabs.push({
              tab: tab,
              tabName: certificate.tabName,
              isComplete: false,
              isDisabled: !isCourseFullyComplete || !isFinalTestComplete || !isCourseEvalComplete,
              isLocked: !isCourseFullyComplete || !isFinalTestComplete || !isCourseEvalComplete
            });
          }
          break;
        case 'resources':
          if (resources.toggle) {
            newTabs.push({
              tab: tab,
              tabName: resources.tabName,
              isComplete: false,
              isDisabled: resources.lockedUntilCompletion && !isCourseFullyComplete,
              isLocked: resources.lockedUntilCompletion && !isCourseFullyComplete
            });
          }
          break;
        default:
        //
      }
    });

    return newTabs;
  }
  function getCurrentTabs() {
    var newTabs = [];

    // First Tab
    if (courseDescription && courseDescription.toggle) {
      newTabs.push('courseDescription');
    }

    // Second Tab
    var showRegistration = showExternalRegistrationDeployment;
    if (registration && registration.toggle && registration.isInternalRegistration) {
      var registrationSurveys = flowList.filter(function (f) {
        return registration.options.includes(f.handle) && !f.isComplete;
      });
      if (registrationSurveys.length) {
        showRegistration = true;
      }
    }
    if (showRegistration) {
      newTabs.push('registration');
    }
    if (!newTabs.includes('registration')) {
      newTabs.push('course');
    }

    // Third Tab
    var thirdTab = getThirdTab();
    if (thirdTab) {
      newTabs.push(thirdTab);
    }

    // Fourth Tab
    if (resources && resources.toggle) {
      if (!isCourseComplete && resources.lockedUntilCompletion) {
        newTabs.push('resources_locked');
      } else {
        newTabs.push('resources');
      }
    }
    return newTabs;
  }
  function getThirdTab() {
    var thirdTab;
    if (finalTest && finalTest.toggle) {
      thirdTab = 'finalTest';
      if (!isFinalTestComplete && finalTest.lockedUntilCompletion) {
        if (!isCourseComplete) {
          thirdTab = 'finalTest_locked';
        }
        if (latestFinalTestData.exceededMaxTries) {
          thirdTab = 'finalTest_locked';
        }
      }
    }
    if (courseEval && courseEval.toggle && isFinalTestComplete) {
      thirdTab = 'courseEval';
      if (!isCourseEvalComplete && courseEval.lockedUntilCompletion) {
        if (!isCourseComplete) {
          thirdTab = 'courseEval_locked';
        }
      }
    }
    if (certificate && certificate.toggle && isFinalTestComplete && isCourseEvalComplete) {
      if (!isCourseComplete) {
        thirdTab = 'certificate_locked';
      } else {
        thirdTab = 'certificate';
      }
    }
    return thirdTab;
  }
  function isTabMediatorComplete(tabKey) {
    if (tabKey === 'course' && course.isCurriculum) {
      return determineCurriculumStatus();
    }
    if (tabKey === 'finalTest' && finalTest && finalTest.useRepeatingFinalTest) {
      return determineFinalTestStatus();
    }
    if (tabKey === 'registration' && showExternalRegistrationDeployment) {
      return false;
    }
    var isComplete = true;
    if (mediatorProps[tabKey] && mediatorProps[tabKey].toggle && (tabKey !== 'registration' || registration.isInternalRegistration)) {
      isComplete = flowList.filter(function (f) {
        return mediatorProps[tabKey].options.includes(f.handle) && !f.isComplete;
      }).length === 0;
    }
    return isComplete;
  }
  function getMediatorTabData() {
    var onCompleteLocations = getOnCompleteLocations();
    var getMustCompleteString = function getMustCompleteString(must, before) {
      return "You must first complete the ".concat(must, " before starting the ").concat(before, ".");
    };
    var getAlreadyCompletedString = function getAlreadyCompletedString(tab) {
      if (tab.completionMessage) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: tab.completionMessage
        });
      }
      return "You have already completed the ".concat(tab.tabName, ".");
    };
    var courseLockedMessage = function courseLockedMessage() {
      if (isRegistrationComplete) {
        return null;
      }
      return course.isCurriculum ? /*#__PURE__*/_react["default"].createElement("span", null, "You must first complete the", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.NavLink, {
        to: basePath + '/registration'
      }, registration.tabName), " before starting the", ' ', course.tabName, ".") : getMustCompleteString(registration.tabName, course.tabName);
    };
    var courseEvalLockedMessage = function courseEvalLockedMessage() {
      if (!isCourseComplete) {
        if (finalTest.toggle) {
          return getMustCompleteString("".concat(course.tabName, " and ").concat(finalTest.tabName), courseEval.tabName);
        }
        return getMustCompleteString(course.tabName, courseEval.tabName);
      }
      if (finalTest.toggle && !isFinalTestComplete) {
        return getMustCompleteString(finalTest.tabName, courseEval.tabName);
      }
      return null;
    };
    return {
      course: {
        completedMessage: isCourseFullyComplete && !course.allowRetake ? getAlreadyCompletedString(course) : null,
        lockedMessage: courseLockedMessage(),
        onCompleteLocation: onCompleteLocations.course
      },
      courseEval: {
        completedMessage: isCourseEvalComplete ? getAlreadyCompletedString(courseEval) : null,
        lockedMessage: courseEvalLockedMessage(),
        onCompleteLocation: onCompleteLocations.courseEval
      },
      finalTest: {
        completedMessage: isFinalTestComplete ? getAlreadyCompletedString(finalTest) : null,
        lockedMessage: !isCourseComplete && finalTest.lockedUntilCompletion ? getMustCompleteString(course.tabName, finalTest.tabName) : null,
        onCompleteLocation: latestFinalTestData.exceededMaxTries ? onCompleteLocations.registration : onCompleteLocations.finalTest
      },
      registration: {
        completedMessage: isRegistrationComplete ? getAlreadyCompletedString(registration) : null,
        onCompleteLocation: onCompleteLocations.registration
      }
    };
  }
  function getOnCompleteLocations() {
    var courseOnComplete = '';
    if (finalTest.toggle && !isFinalTestComplete) {
      courseOnComplete = 'finalTest';
    } else if (courseEval.toggle && !isCourseEvalComplete) {
      courseOnComplete = 'courseEval';
    } else if (certificate.toggle && !hasVisitedCertificate) {
      courseOnComplete = 'certificate';
    }
    var finalTestOnComplete = '';
    if (courseEval.toggle) {
      finalTestOnComplete = 'courseEval';
    } else if (certificate.toggle) {
      finalTestOnComplete = 'certificate';
    }
    var courseEvalOnComplete = certificate.toggle ? 'certificate' : '';
    var addFullPath = function addFullPath(path) {
      if (!path) {
        return null;
      }
      return "".concat(basePath, "/").concat(path);
    };
    return {
      registration: addFullPath('course'),
      course: latestFinalTestData.recentlyExceededMaxTries ? addFullPath('course') : addFullPath(courseOnComplete),
      finalTest: addFullPath(finalTestOnComplete),
      courseEval: addFullPath(courseEvalOnComplete)
    };
  }
  function onClickTab(tabKey) {
    history.push("".concat(basePath, "/").concat(tabKey));
  }
  function onFlowCompleteLocal(_x2) {
    return _onFlowCompleteLocal.apply(this, arguments);
  }
  function _onFlowCompleteLocal() {
    _onFlowCompleteLocal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(flow) {
      var completionInfo,
        _args9 = arguments;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              completionInfo = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
              return _context9.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(resolve) {
                  var updatedFlowList, subMediatorData;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          if (!flow.isComplete) {
                            flow.completedLocally = true;
                          }
                          flow.isComplete = true;
                          updatedFlowList = [].concat(_toConsumableArray(flowList.filter(function (f) {
                            return f.handle !== flow.handle;
                          })), [flow]).sort(sortByOrdinalPosition);
                          setFlowList(updatedFlowList);
                          _context8.next = 6;
                          return onFlowComplete(flow, completionInfo);
                        case 6:
                          _context8.next = 8;
                          return tryAssignmentComplete({
                            updatedFlowList: updatedFlowList
                          });
                        case 8:
                          subMediatorData = getMediatorTabData()[currTab];
                          if (['registration', 'course', 'courseEval', 'finalTest'].includes(currTab) && isTabMediatorComplete(currTab) && subMediatorData.onCompleteLocation) {
                            history.push(subMediatorData.onCompleteLocation);
                          }
                          return _context8.abrupt("return", resolve());
                        case 11:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8);
                }));
                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));
    return _onFlowCompleteLocal.apply(this, arguments);
  }
  function onFlowStartedLocal(_x3) {
    return _onFlowStartedLocal.apply(this, arguments);
  }
  function _onFlowStartedLocal() {
    _onFlowStartedLocal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(flow) {
      var updatedFlowList;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              flow.isStarted = true;
              _context10.next = 3;
              return onFlowStarted(flow);
            case 3:
              updatedFlowList = [].concat(_toConsumableArray(flowList.filter(function (f) {
                return f.handle !== flow.handle;
              })), [flow]).sort(sortByOrdinalPosition);
              setFlowList(updatedFlowList);
            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return _onFlowStartedLocal.apply(this, arguments);
  }
  function sortByOrdinalPosition(e1, e2) {
    if (e1.ordinalPosition < e2.ordinalPosition) {
      return -1;
    }
    if (e1.ordinalPosition > e2.ordinalPosition) {
      return 1;
    }
    return 0;
  }
  function tryAssignmentComplete(_x4) {
    return _tryAssignmentComplete.apply(this, arguments);
  }
  function _tryAssignmentComplete() {
    _tryAssignmentComplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_ref4) {
      var finalTestComplete, _ref4$updatedFlowList, updatedFlowList, localIsFinalTestComplete, localFlowList, isLocalFlowsComplete, isAllFlowsComplete;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              finalTestComplete = _ref4.finalTestComplete, _ref4$updatedFlowList = _ref4.updatedFlowList, updatedFlowList = _ref4$updatedFlowList === void 0 ? null : _ref4$updatedFlowList;
              localIsFinalTestComplete = finalTestComplete || isFinalTestComplete;
              localFlowList = updatedFlowList || flowList;
              isLocalFlowsComplete = localFlowList.every(function (f) {
                return f.isComplete || !f.isRequired;
              });
              isAllFlowsComplete = isLocalFlowsComplete && (!course.isCurriculum || isCourseFullyComplete);
              if (!(!hasCompletedLocally && (!startedComplete || !finalTestStartedComplete) && isAllFlowsComplete && (!isRepeatedFinalTest || localIsFinalTestComplete))) {
                _context11.next = 12;
                break;
              }
              setHasCompletedLocally(true);
              setFinalTestStartedComplete(true);
              _context11.next = 10;
              return onAssignmentComplete();
            case 10:
              _context11.next = 12;
              return onComplete();
            case 12:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return _tryAssignmentComplete.apply(this, arguments);
  }
  return {
    availableTabs: availableTabs,
    currentTabs: currentTabs,
    currTab: currTab,
    curriculumProps: curriculumProps,
    flowList: flowList,
    isCourseComplete: isCourseComplete,
    isCourseEvalComplete: isCourseEvalComplete,
    isFinalTestComplete: isFinalTestComplete,
    isLoading: isExternalRegistrationLoading,
    isRegistrationComplete: isRegistrationComplete,
    isRepeatedFinalTest: isRepeatedFinalTest,
    isTabMediatorComplete: isTabMediatorComplete,
    latestFinalTestData: latestFinalTestData,
    mediatorTabData: getMediatorTabData(),
    onClickTab: onClickTab,
    onExternalRegistrationComplete: function onExternalRegistrationComplete() {
      setIsExternalRegistrationCompleteLocally(true);
      if (!registration.isInternalRegistration || registration.options.length === 0) {
        history.push("".concat(basePath, "/course"));
      }
    },
    onFinalTestComplete: function onFinalTestComplete() {
      setFinalTestDataRetrievedCount(finalTestDataRetrievedCount + 1);
    },
    onFlowCompleteLocal: onFlowCompleteLocal,
    onFlowStartedLocal: onFlowStartedLocal,
    relatedDeploymentId: relatedDeploymentId,
    setFlowList: setFlowList,
    showExternalRegistrationDeployment: showExternalRegistrationDeployment
  };
};
exports.useCourseWrapperMediator = useCourseWrapperMediator;
useCourseWrapperMediator.propTypes = {
  actingPawnId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  basePath: _propTypes["default"].string,
  isPreviewMode: _propTypes["default"].bool,
  mediatorProps: _propTypes["default"].object,
  onAssignmentComplete: _propTypes["default"].func,
  onFlowComplete: _propTypes["default"].func,
  onFlowStarted: _propTypes["default"].func,
  originalFlowList: _propTypes["default"].array.isRequired
};
var _default = useCourseWrapperMediator;
exports["default"] = _default;